
jQuery(document).ready(function (){
    setTimeout(function() {
      jQuery('label[for="purchaseOption--subscribe"]').trigger('click');
    }, 800);
  $('.selling-plans').on('click',function(){
   $(this).find('input[type="radio"]').prop('checked', true);
   jQuery('label[for="purchaseOption--subscribe"]').trigger('click');
    $('.details').removeClass('active');
    $(this).find('.details').addClass('active');
    var plan_id = $(this).attr('plans-id');
    if (plan_id) {
      jQuery('#select-selling-plan').val(plan_id);
    }
  });
  $(document).on('click', '.purchaseOptions__option--oneTime', function () {
     $('.selling-plans').find('input[type="radio"]').prop('checked', false);
     $('.selling-plans').find('.details').removeClass('active');
  });
});
